import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { styled, useTheme } from "@mui/material/styles";
import React from "react";
const classes = {
    root: "pagination-root"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`&.${classes.root}`]: { flexShrink: 0, marginLeft: theme.spacing(2.5) }
}));
export const PaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (React.createElement(StyledDiv, { className: classes.root },
        React.createElement(IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page", size: "large" }, theme.direction === "rtl" ? React.createElement(LastPageIcon, null) : React.createElement(FirstPageIcon, null)),
        React.createElement(IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page", size: "large" }, theme.direction === "rtl" ? React.createElement(KeyboardArrowRight, null) : React.createElement(KeyboardArrowLeft, null)),
        React.createElement(IconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page", size: "large" }, theme.direction === "rtl" ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowRight, null)),
        React.createElement(IconButton, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page", size: "large" }, theme.direction === "rtl" ? React.createElement(FirstPageIcon, null) : React.createElement(LastPageIcon, null))));
};
